import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProblemReframe } from './components/ProblemReframe';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { TimeFlexibility } from './components/TimeFlexibility';
import { IncludesSection } from './components/IncludesSection';
import { AudienceSection } from './components/AudienceSection';
import { PricingSection } from './components/PricingSection';
import { StickyCtaBar } from './components/StickyCtaBar';
import { Footer } from './components/Footer';
export function App() {
  return <main className="bg-[#0A0A0A] min-h-screen text-white selection:bg-[#2563EB] selection:text-white font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <ProblemReframe data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <MechanismSection data-id="element-5" />
      <TimeFlexibility data-id="element-6" />
      <IncludesSection data-id="element-7" />
      <AudienceSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <Footer data-id="element-10" />
      <StickyCtaBar data-id="element-11" />
    </main>;
}